import type { ReactNode } from "react";

import { SidebarInset, SidebarProvider } from "@/components/ui/sidebar";

import { GravunSidebar } from "../navigation/GravunSidebar";
import { GravunTopbar } from "./GravunTopbar";

/**
 * The Gravun application shell: persistent sidebar + top bar + content area.
 * Reused by every module. Width tokens follow the design reference
 * (~220px expanded sidebar, 56px topbar, 28-36px page padding).
 */
export const GravunShell = ({ children }: { children: ReactNode }) => (
  <SidebarProvider
    style={
      {
        "--sidebar-width": "13.75rem",
        "--sidebar-width-icon": "3rem",
      } as React.CSSProperties
    }
  >
    <GravunSidebar />
    <SidebarInset className="bg-background">
      <GravunTopbar />
      <div className="flex-1 px-7 py-6 max-md:px-4" id="main-content">
        {children}
      </div>
    </SidebarInset>
  </SidebarProvider>
);
